// src/pages/Dashboard.js
import React from 'react';
import { Grid, Card, CardActionArea, CardContent, Typography, Box, useTheme, useMediaQuery } from '@mui/material';
import { NavLink } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaidIcon from '@mui/icons-material/Paid';

const shortcutItems = [
  { label: 'Dashboard', icon: <DashboardIcon fontSize="large" />, link: '/dashboard' },
  { label: 'Attendance', icon: <EventAvailableIcon fontSize="large" />, link: '/att' },
  { label: 'Bill Book', icon: <PaidIcon fontSize="large" />, link: '/bill' },
  { label: 'Credit Sales', icon: <PointOfSaleIcon fontSize="large" />, link: '/sales' },
  { label: 'Customers', icon: <StorefrontIcon fontSize="large" />, link: '/customers' },
  { label: 'Salary', icon: <PaidIcon fontSize="large" />, link: '/sal' },
  { label: 'Bonus & Penalties', icon: <PaidIcon fontSize="large" />, link: '/bonus' },
  { label: 'Staff', icon: <SupervisorAccountIcon fontSize="large" />, link: '/staff' },
  
  
  { label: 'Loans', icon: <AccountBalanceWalletIcon fontSize="large" />, link: '/loan' },
  
  
];

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={2}>
        {shortcutItems.map((item, idx) => (
          <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
            <Card>
              <CardActionArea component={NavLink} to={item.link}>
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 120,
                  }}
                >
                  {item.icon}
                  <Typography variant="h6" align="center" sx={{ mt: 1 }}>
                    {item.label}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
